import React from 'react'
import * as S from './styles'
type Props = {
  body?: any
  title?: string
}
const BillingCard = ({ body, title }: Props) => {
  return (
    <S.Wrapper>
      <S.Header>{title}</S.Header>
      <S.Body>{body}</S.Body>
    </S.Wrapper>
  )
}
export default BillingCard
